define('SearchSpring.ItemSearcher.Results.View', [
    'Backbone',
    'typeahead_searchspring.tpl'
], function SearchSpringITemSearcherResultsView(
    Backbone,
    typeAheadSearchSpringTpl
) {
    'use strict';

    return Backbone.View.extend({
        template: typeAheadSearchSpringTpl,
        events: {
            'keydown .typehaead-searchspring-term-link':'openSubMenu',
            'focusout .typeahead-searchspring-container':'focusOutSearch'
        },
        focusOutSearch: function focusOutMiniCart(e) {
            var $el = jQuery(e.currentTarget);
            if (!$el.has(e.relatedTarget).length) {
                $el.remove();
            }
        },
        openSubMenu: function openSubMenu(e){
            var $el = jQuery(e.currentTarget);
            if (e.keyCode === 32) {
                e.preventDefault();
                $el.trigger('mouseenter')
                this.$('.typehaead-searchspring-facets').focus();
            }
        },
        getContext: function getContext() {
            if (!this.data) return {};
            return {
                searchVal: this.data.searchVal,
                items: this.data.items,
                searchTerms: this.data.terms,
                facets: this.data.facets,
                didYouMean: this.data.didYouMean,
                showResults: !!(this.data.items && this.data.items.length)
            };
        }
    });
});
